import React from "react";
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";

import "./CampaignDetailsPage.scss";

const CampaignAdElement = (props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const copySource = () => {
    navigator.clipboard.writeText(props.ad['source_' + props.size]).then(() => {
      enqueueSnackbar(t("CampaignAdsBox.CopySuccess"), {variant:'success'});
    });
  }

  return (
    <div className={'campaign-ads__element'} onClick={copySource} title={props.ad.name}>
      <div className={'preview'} dangerouslySetInnerHTML={{__html: props.ad['preview_' + props.size]}}/>
    </div>
  );
}

export default CampaignAdElement;